import type React from 'react';

export type TransitIconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const TransitIcon: React.FC<TransitIconProps> = ({ size = '24', color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="FILLED">
        <path d="M10.6592,5.9863h-9a.375.375,0,0,0-.375.375v4a.3751.3751,0,0,0,.375.375h9a.3751.3751,0,0,0,.375-.375v-4a.375.375,0,0,0-.375-.375Zm-.375,4h-8.25v-3.25h8.25Z" />
        <path d="M13.9156,4.5168a.3751.3751,0,0,0,.07-.3206l-.5937-2.4453a.3746.3746,0,0,0-.3644-.2865H1.6211a.375.375,0,0,0-.375.375V4.2559a.3745.3745,0,0,0,.3741.375l12,.0288A.3751.3751,0,0,0,13.9156,4.5168ZM4.4082,3.8875,1.9961,3.8817V2.2144H4.4082Zm2.9482.0071L5.1582,3.8893V2.2144H7.3564Zm2.9482.0071L8.1064,3.8964V2.2144h2.1982Zm.75.0018V2.2144h1.6778l.4114,1.6942Z" />
        <path d="M15.9241,6.2645l-.01-.0826-1.44-5.906A.3611.3611,0,0,0,14.1243,0H.36A.3609.3609,0,0,0,.1054.1061.3657.3657,0,0,0,0,.3623V13.6377a.3657.3657,0,0,0,.1054.2562A.3609.3609,0,0,0,.36,14H1.3651a2.3655,2.3655,0,0,0,4.6742,0H9.6726a2.3655,2.3655,0,0,0,4.6742,0H15.64a.3586.3586,0,0,0,.2557-.1075A.3635.3635,0,0,0,16,13.6339Zm-.675,4.3326-.0064-.6221H12.9355v-3.25h2.2737L15.205,6.314ZM3.7021,15.25a1.625,1.625,0,1,1,1.625-1.625A1.6274,1.6274,0,0,1,3.7021,15.25Zm8.3076,0a1.625,1.625,0,1,1,1.625-1.625A1.6274,1.6274,0,0,1,12.01,15.25Zm2.34-1.9747a2.3641,2.3641,0,0,0-4.6793,0H6.0418a2.3641,2.3641,0,0,0-4.6793,0H.72V.7246H13.8421l1.28,5.25H12.5605a.375.375,0,0,0-.375.375v4a.3751.3751,0,0,0,.375.375h2.69l.0262,2.55Z" />
      </g>
    </svg>
  );
};
